module fdm {
    class NoConnectionHandlerController{}

    angular.module('fdm')
        .component('noConnectionHandler', {
            controller: NoConnectionHandlerController,
            template: '<div class="text-center m-b-lg"> <h1 class="text-shadow text-white">Unable to connect to the Internet</h1></div><div class="container w-xxl w-auto-xs" ng-init="app.settings.container = false;"> <div class="list-group bg-info auto m-b-sm m-b-lg"> <a href="javascript:window.location.reload();" class="list-group-item"> <i class="fa fa-chevron-right text-muted"></i> <i class="fa fa-fw fa-sign-in m-r-xs"></i> Reload </a> </div></div>'
        });
}